<template>
    <div class="animated fadeIn">
        <DynamicForm
                v-model="dataId"
                :options=" {
                        submit: {
                            text: Core.Definition.getDefinition('Enregistrer'),
                            variant: 'success'
                        }
                }"
                ref="dynamicForm"
                getRoot="/user-setting/auto-notifications"
                saveRoot="/user-setting/auto-notifications"
                @onSave="onSave"
                @onRequestSuccess="onRequestSuccess"
                :formStructure="dataFormStructures.role">
            <slot slot="afterForm">
                <b-row>
                    <b-col class="card-columns">
                        <b-card :key="autoNotificationIndex" v-for="autoNotification, autoNotificationIndex in dataAutoNotifications">
                            <div slot="header">
                                {{autoNotification.title}}<br/>
                                <small>
                                    {{autoNotification.description}}
                                </small>
                            </div>
                            <b-row>
                                <b-col>
                                    <InputCheckbox
                                            :label="Core.Definition.getDefinition('Réception par SMS')"
                                            v-model="autoNotification.sms.activated"
                                            :labelCols="6"></InputCheckbox>
                                </b-col>
                                <b-col>
                                    <InputCheckbox
                                            :label="Core.Definition.getDefinition('Réception par courriel')"
                                            v-model="autoNotification.email.activated"
                                            :labelCols="6"></InputCheckbox>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>

            </slot>
        </DynamicForm>
    </div>
</template>

<script>
    import DynamicForm from '../../../components/DynamicForm'
    import InputCheckbox from '../../../components/InputCheckbox'
    export default {
        name: 'UserSettingsAutoNotifications',
        components: {
            DynamicForm,
            InputCheckbox,
        },
        mounted() {
        },
        data: function () {
            return {
                dataAutoNotifications: [],
                Core: window.Core,
                dataId: '',
                dataFormStructures: {
                    role: {
                        rows: [],
                        fields: []
                    }
                }
            }
        },
        methods: {
            onSave() {
                let userSettings = []
                for(let autoNotification in this.dataAutoNotifications) {
                    autoNotification = this.dataAutoNotifications[autoNotification]
                    if (autoNotification.sms !== undefined && autoNotification.email !== undefined) {
                        userSettings.push({
                            key: autoNotification.key + '.sms.activated',
                            value: Core.Value.decode(autoNotification.sms.activated, Core.Value.typeCheckbox)
                        })
                        userSettings.push({
                            key: autoNotification.key + '.email.activated',
                            value: Core.Value.decode(autoNotification.email.activated, Core.Value.typeCheckbox)
                        })
                    }
                }
                this.$refs.dynamicForm.addSaveArg('userSettings', userSettings, Core.Value.typeJSON)
            },
            onRequestSuccess(data) {
                if (data.autoNotifications !== undefined) {
                    this.dataAutoNotifications = data.autoNotifications
                }
            }
        }
    }
</script>
